module.exports = __webpack_public_path__ + "static/img/loading.20d5c35.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/loading.gif
// module id = JRsF
// module chunks = 86